import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/app/App';
import SentryService from './services/Sentry.service';

SentryService.init();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
